// Browser push notifications for admin devices (installed dashboard on a phone).
import { fetchWrapper } from '@/helpers';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

export const pushSupported = () =>
    typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = window.atob(base64);
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function registration() {
    return (await navigator.serviceWorker.getRegistration('/')) || navigator.serviceWorker.register('/sw.js', { scope: '/' });
}

// Current state for this browser: 'unsupported' | 'denied' | 'on' | 'off'
export async function pushState() {
    if (!pushSupported()) return 'unsupported';
    if (Notification.permission === 'denied') return 'denied';
    const reg = await registration();
    const sub = await reg.pushManager.getSubscription();
    return sub ? 'on' : 'off';
}

export async function enablePush() {
    if (!pushSupported()) throw new Error('This browser does not support notifications');
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') throw new Error('Notifications were not allowed');
    const { publicKey } = await fetchWrapper.get(`${baseUrl}/push/public-key`);
    const reg = await registration();
    const sub = (await reg.pushManager.getSubscription())
        || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(publicKey) }));
    await fetchWrapper.post(`${baseUrl}/push/subscribe`, { subscription: sub.toJSON() });
    return 'on';
}

export async function disablePush() {
    if (!pushSupported()) return 'unsupported';
    const reg = await registration();
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
        try { await fetchWrapper.post(`${baseUrl}/push/unsubscribe`, { endpoint: sub.endpoint }); } catch (_) { /* best effort */ }
        await sub.unsubscribe();
    }
    return 'off';
}

export async function sendTestPush() {
    return fetchWrapper.post(`${baseUrl}/push/test`, {});
}
